import React from 'react';
import PageList from '../../../components/PageListAPI'
import { useDispatch } from 'react-redux';
import { adminSUList, adminSUMerge } from '../../../api/list'
import { useHistory, useLocation } from 'react-router-dom'
import { Button } from '@mui/material';
import { fetchDispath } from '../../../functions/fetch'
import { enqueueSnackbar } from '../../../reducers/notifier'

export default function OkeiNotList() {
  const location = useLocation()
  const history = useHistory()
  const dispatch = useDispatch()
  const handleMerge = () => {
    dispatch(fetchDispath({
      progress: true,
      request: adminSUMerge,
    })).then(res => {
      if (res.success) {
        dispatch(enqueueSnackbar({
          message: 'Успех',
          options: { variant: 'success' }
        }))
      }
      else {
        dispatch(enqueueSnackbar({
          message: 'error',
          options: { variant: 'error' }
        }))
      }
    })
  }
  return (
    <div className='App-paper'>
      <PageList
        name='region-list'
        columns={[
          { id: 'id', name: 'ID', },
          { id: 'name', name: 'Название единицы измерения', },
          { id: 'accountId', name: 'Аккаунт', },
        ]}
        createItem={false}
        deleteItem={false}
        loadAPI={{
          request: adminSUList,
        }}
        headerLink={<Button key='set-price' onClick={handleMerge} color="primary" >Склеить</Button>}
        location={location}
        history={history}
      />
    </div>
  )
};

